"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _bookmarkContext = _interopRequireDefault(require("../context/bookmarkContext"));

var _bookmarkSettingsContext = _interopRequireDefault(require("../context/bookmarkSettingsContext"));

var _userContext = _interopRequireDefault(require("@micado-digital/react-internal/context/userContext"));

var _readStorage = _interopRequireDefault(require("../utils/readStorage"));

var _updateStorage = _interopRequireDefault(require("../utils/updateStorage"));

var _saveBookmarkDataToServer = _interopRequireDefault(require("../utils/saveBookmarkDataToServer"));

var _sync = _interopRequireDefault(require("../utils/sync"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var BookmarkRoot = function BookmarkRoot(props) {
  var _useContext;

  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var _props$localStorageKe = props.localStorageKey,
      localStorageKey = _props$localStorageKe === void 0 ? "react-bookmark" : _props$localStorageKe,
      _props$readURL = props.readURL,
      readURL = _props$readURL === void 0 ? REACT_APP_PATH + "/Micado.WebEngine/Micado.WebEngine.Plugin.Address/ReadBookmarkData.api" : _props$readURL,
      _props$writeURL = props.writeURL,
      writeURL = _props$writeURL === void 0 ? REACT_APP_PATH + "/Micado.WebEngine/Micado.WebEngine.Plugin.Address/SaveBookmarkData.api" : _props$writeURL;

  var _useState = (0, _react.useState)({
    localStorageKey: localStorageKey,
    readURL: readURL,
    writeURL: writeURL
  }),
      _useState2 = _slicedToArray(_useState, 2),
      bookmarkSettings = _useState2[0],
      setBookmarmSettings = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _readStorage.default)(bookmarkSettings.localStorageKey)),
      _useState4 = _slicedToArray(_useState3, 2),
      bookmarkData = _useState4[0],
      setBookmarkData = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      avoidSave = _useState6[0],
      setAvoidSave = _useState6[1]; // state to avoid useless save


  var userData = (_useContext = (0, _react.useContext)(_userContext.default)) === null || _useContext === void 0 ? void 0 : _useContext[0]; // sync bookmark data

  (0, _react.useEffect)(function () {
    function executeSync() {
      return _executeSync.apply(this, arguments);
    }

    function _executeSync() {
      _executeSync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _sync.default)(bookmarkSettings.readURL, bookmarkData);

              case 2:
                response = _context.sent;

                // update context
                // avoid save if not required
                if (response.updateRequired === false) {
                  setAvoidSave(true);
                }

                setBookmarkData(response.mergedBookmarkData); // update local storage

                (0, _updateStorage.default)(bookmarkSettings.localStorageKey, response.mergedBookmarkData);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _executeSync.apply(this, arguments);
    }

    if (!(0, _isEmpty.default)(userData)) {
      executeSync();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [userData]); // save bookmark data

  (0, _react.useEffect)(function () {
    function saveData() {
      return _saveData.apply(this, arguments);
    } // save data only if avoidSave is not true
    // avoid save after login


    function _saveData() {
      _saveData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                (0, _saveBookmarkDataToServer.default)(bookmarkSettings.writeURL, bookmarkData);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _saveData.apply(this, arguments);
    }

    if (!(0, _isEmpty.default)(userData) && avoidSave !== true) {
      saveData();
    }

    if (avoidSave) setAvoidSave(false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookmarkData]); // listen on logout

  (0, _react.useEffect)(function () {
    document.body.addEventListener("mco-logout", function () {
      setBookmarkData([]);
      (0, _updateStorage.default)(bookmarkSettings.localStorageKey, []);
    }, false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_bookmarkSettingsContext.default.Provider, {
    value: [bookmarkSettings, setBookmarmSettings]
  }, /*#__PURE__*/_react.default.createElement(_bookmarkContext.default.Provider, {
    value: [bookmarkData, setBookmarkData]
  }, props.children));
};

BookmarkRoot.propTypes = {
  localStorageKey: _propTypes.default.string,
  readURL: _propTypes.default.string,
  writeURL: _propTypes.default.string
};
var _default = BookmarkRoot;
exports.default = _default;